export default __webpack_public_path__ + "static/media/logo1.35583ce5.svg";